"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalConversions = void 0;
exports.setPhysicsModel = setPhysicsModel;
exports.getPhysicsModel = getPhysicsModel;
const models_1 = require("../models");
const conversions_1 = require("./conversions");
const engines_1 = require("./engines");
const model_1 = require("./model");
const ballParamsBySport = Object.fromEntries(models_1.Sports.map((sport) => [sport, { ...models_1.BallParamsBySport[sport] }]));
const PHYSICSMODEL = (0, model_1.createModel)("physics-20B-base", "PLATFORM_TENNIS", {
    ballParams: ballParamsBySport.PLATFORM_TENNIS,
    constants: { ...models_1.DefaultPhysicalConstants },
    simParams: { ...models_1.DefaultSimulationParams },
});
let conversions = new conversions_1.Conversions(PHYSICSMODEL, (0, engines_1.baseEngine)(PHYSICSMODEL.name, PHYSICSMODEL.sport));
/** The conversions of the global model as it is set now. */
const globalConversions = () => conversions;
exports.globalConversions = globalConversions;
/**
 * Set the model every conversion reads, changing the model object in place
 * as v1 does. A pair with no speed table is accepted, as in v1; the
 * conversions that need one throw for it (see engines.ts).
 */
function setPhysicsModel(physicsModelName, sport) {
    (0, model_1.assertModel)(physicsModelName, sport);
    const engine = (0, engines_1.baseEngine)(physicsModelName, sport);
    const { limits, ...model } = (0, model_1.createModel)(physicsModelName, sport, {
        ballParams: ballParamsBySport[sport],
        constants: PHYSICSMODEL.constants,
        simParams: PHYSICSMODEL.simParams,
    });
    Object.assign(PHYSICSMODEL, model);
    PHYSICSMODEL.limits.RPM = limits.RPM;
    Object.assign(PHYSICSMODEL.limits.MPS, limits.MPS);
    conversions = new conversions_1.Conversions(PHYSICSMODEL, engine);
}
/** The global model: the same object on every call. */
function getPhysicsModel() {
    return PHYSICSMODEL;
}
